import type { ILogging } from '../../../api/types/ILogging';
import type { UnknownObject } from '../../../types';
export type LoggingChannel =
  | 'firebase'
  | 'amplitude'
  | 'braze'
  | 'ablylog'
  | 'facebook'
  | 'airbridge'
  | 'pixel';

export const LOG_ANALYTICS_ALL_CHANNELS: Array<LoggingChannel> = [
  'firebase',
  'amplitude',
  'braze',
  'ablylog',
  'facebook',
  'airbridge',
];
export type LogAnalyticsEventParams = {
  channel?: Array<LoggingChannel>;
  name: string;
  /**
   * - 키는 대문자, snake case로 작성합니다.
   * - SCREEN이 있는지 확인해주세요
   */
  analytics?: UnknownObject;
  ably_only_log?: UnknownObject;
  ignoreAblyLog?: boolean;
  /**
   * ILogging을 전달하면 analytics, ably_only_log를 자동으로 추출합니다.
   * analytics, ably_only_log와 함께 사용하면 logging 값 위에 머지됩니다.
   */
  logging?: ILogging;
};
